import React from 'react'
import {SidebarOption} from "components";
import {Drawer, List} from "@material-ui/core";

const MobileDrawer = (props) => {
    const {
        open,
        tabs,
        user,
        subTabs,
        classes,
        setOpen,
        directory,
        matchesXS,
        handleCollapse,
        handleNavigate,
    } = props
    return (
        <Drawer open={open}
                variant="temporary"
                onClose={() => setOpen(false)}
                classes={{paper: classes.drawerPaper}}
        >
            <div className={classes.toolbarMargin}/>
            {   /*==========   Mobile Sidebar Options     ==========*/}
            <List>
                {directory && directory.map(({id, label, icon, slug, total}) =>
                    <SidebarOption key={id}
                                   Icon={icon}
                                   tabs={tabs}
                                   title={label}
                                   number={total}
                                   xs={matchesXS}
                                   subTabs={subTabs}
                                   navigate={`/${slug}`}
                                   close={() => setOpen(false)}
                                   memberType={user.member_type}
                                   handleCollapse={handleCollapse}
                                   handleNavigate={handleNavigate}
                    />
                )}
            </List>
        </Drawer>
    )
};

export default MobileDrawer;